function BetalingMislukt() {
  return (
    <>
      {/* Navigatie */}
      <nav className="d-none">
        <div className="container">
          <div className="row align-items-center justify-content-end">
            <div className="logo">
              <a href="#">
                <img src="/img/hlp-logo-wit.svg" alt="Logo Healthy Living Project" />
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Header */}
      <div className="page__header" style={{ backgroundImage: `url('/img/page-header/page-header-bg.png')`, height: '100vh' }}>
        <div className="container">
          <div className="row">
            <div className="header__img">
              <img className="w-100" src="/img/page-header/stef-ridder-img.png" alt="" />
            </div>
            <div className="col-md-7 ml-auto mt-5 mt-md-0">
              <div className="header__content">
                <h5>Er is iets misgegaan met de betaling</h5>
                <h1>Excuus. We gaan er achteraan!</h1>
                <p className="mb-2">
                  Er is mogelijk iets misgegaan met je betaling. Is je geld wel afgeschreven? Neem dan contact op via info@healthyliving-project.com  
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BetalingMislukt;